import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { BoxProps } from '@chakra-ui/react';
import { Icon, Text, Button, Colors, Input } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import { formatInteger } from 'utils/format';

const containerStyle = {
  justifyContent: 'center',
  width: '100%',
  columnGap: 'padding_16',
};

const labelStyle = {
  columnGap: 'padding_8',
};

const inputStyle = {
  width: '54px',
  textAlign: 'center',
  fontSize: '16px',
  fontWeight: '600',
  padding: '4px',
};

type ControlProps = {
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
  onPrev?: () => void;
  onNext?: () => void;
  setPage?: (page: number) => void;
  sx?: BoxProps['sx'];
};

export const Pagination = ({
  totalPages,
  currentPage,
  isLoading,
  onPrev,
  onNext,
  setPage,
  sx = {},
}: ControlProps) => {
  const [pageValue, setPageValue] = useState(currentPage.toString());

  useEffect(() => {
    setPageValue(currentPage.toString());
  }, [currentPage]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPageValue(e.target.value);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setPage?.(Number(pageValue));
  };

  const style = { ...containerStyle, ...sx };

  return (
    <FlexRow sx={style}>
      <Button
        variant="functional"
        isDisabled={isLoading || currentPage === 1}
        onClick={onPrev}
      >
        <Icon name={Icon.Name.ChevronLeft} size={18} />
      </Button>
      <FlexRow sx={labelStyle}>
        <Text color={Colors.TextQuiet}>Page</Text>
        <form onSubmit={handleSubmit}>
          <Input
            disabled={isLoading}
            value={pageValue}
            onChange={handleChange}
            data-testid="page-input"
            sx={inputStyle}
          />
        </form>
        <Text color={Colors.TextQuiet}>of</Text>
        <Text.LargeBold>{formatInteger(totalPages)}</Text.LargeBold>
      </FlexRow>
      <Button
        variant="functional"
        isDisabled={isLoading || currentPage === totalPages}
        onClick={onNext}
      >
        <Icon name={Icon.Name.ChevronRight} size={18} />
      </Button>
    </FlexRow>
  );
};
